import { useCallback } from "react";

import { PARNASSUS_HOST } from "@/challenges/utils/constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useChallengeReportStudentsGet = () => {
  const createEventRecordRequest = useCallback((params) => {
    const challengeId = params.challengeId;
    const classroomId = params.classroomId;

    const baseUrl = `${PARNASSUS_HOST}/challenges/${challengeId}/report/students`;

    const queryParams =
      classroomId !== undefined ? `?classroom_id=${classroomId}` : "";

    const url = `${baseUrl}${queryParams}`;

    const requestConfig = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    return new Request(url, requestConfig);
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useChallengeReportStudentsGet;
